define('pages/claim/ClaimController',[
    'jquery',
    'core/can',
    'models/Session',
    'models/Claim',
    'models/Provider',
    'models/Patient',
    'models/ConditionCode',
    'pages/claim/Patient/PatientComponent',
    'pages/claim/Physician/PhysicianComponent',
    'pages/claim/ConditionCode/ConditionCodeComponent',
    'pages/claim/OccurrenceCode/OccurrenceCodeComponent',
    'pages/claim/ValueCode/ValueCodeComponent',
    'pages/claim/ServiceLine/ServiceLineComponent',
    'pages/claim/DiagnosisCode/DiagnosisCodeComponent',
    'template!pages/claim/LayoutView.stache',
    'template!pages/claim/SummaryView.stache',
    'template!pages/claim/EditView.stache',
    'moment'
], function ($, can,

    // Models
    Session,
    Claim,
    Provider,
    Patient,
    ConditionCode,

    // Components
    c1, c2, c3, c4, c5, c6, c7,

    // Templates
    LayoutView,
    SummaryView,
    EditView,

    moment
) {

        return can.Control.extend({

            defaults: {
                animation: {
                    open: 'fadeInRight',
                    close: 'fadeOutRight'
                }
            }

        }, {

                init: function (el, options) {
                    var self = this,

                        scope = this.scope = new can.Map({
                            isEditing: false,
                            element: this.element,
                            Providers: Session.attr('Providers'),
                            // Admission date should not allow you to schedule a future date.
                            AdmissionDateEndDate: moment().format(),
                            isAuthorizedBiller: can.compute(function () {
                                return Session.attr('isAuthorizedBiller');
                            })
                        });

					/*render = can.proxy(function(claim) {					
					}, this);*/

                    // Open side navigation when editing
                    scope.bind('isEditing', function (e, val) {
                        self[(val ? 'open' : 'close') + 'Aside']();
                    });

                    if (can.route.attr('new') !== undefined) {

                        var claim = new Claim;

                        if (can.route.attr('new') === 'local') {
                            // TODO browser compatability
                            var data = localStorage.getItem('Claim');
                            if (data) {
                                claim.attr(JSON.parse(data));
                                // localStorage.removeItem('Claim');
                            }
                        }

                        this.render(claim);
                        scope.attr('isEditing', true);

                    } else if (can.route.attr('id')) {
                        // Fetch Claim
                        this.getClaimDetails(can.route.attr('id'));

                    } else {
                        can.route.attr({ page: 'claims' }, true);
                    }
                },

                isCancelable: function () {
                    var isPaid = this.scope.attr('Claim._isPaid');
                    var isInB9997 = this.scope.attr('Claim.LocationCode') === "B9997";
                    var isCanceled = this.scope.attr('Claim.CancelDate');
                    var isProcessingCancel = this.scope.attr('Claim._isProcesing');

                    return (isPaid || isInB9997) && !isCanceled && !isProcessingCancel;
                },

                render: function (claim) {
                    claim.attr('TreatmentAuthorizationCodes', claim.attr('TreatmentAuthorizationCodes') || []);
                    var el = this.element,
                        scope = this.scope;

                    scope.attr('Claim', claim);
                    scope.attr('isCancelable', this.isCancelable());
                    scope.attr('isEditing', false);
                    App.loading(false);

                    // Render
                    el.html(can.view(LayoutView, scope, {
                        ifExistsPatientStatus: function (options) {
                            var ps = options.context().attr('PatientStatus'),
                                exists = !(ps === undefined || ps === null || ps === 0);
                            if (exists) {
                                return options.fn();
                            } else {
                                return options.inverse();
                            }
                        },
                        ConditionCodeDescription: function (code) {
                            var model = new ConditionCode({ Code: code });
                            return model.attr('_Description');
                        }
                    }));

                    // Cache Elements
                    this.aside = el.find('aside>div');
                    this.content = el.find('.content');

                    // Siderbar affix
                    $('aside').affix({
                        offset: {
                            top: 75,
                            bottom: 100
                        }
                    });
                },

                getClaimDetails: function (id) {
                    var self = this;
                    App.loading();
                    Claim.findOne({ id: id }, function (claim) {
                        // Keep clean version of claim so we can cancel editing
                        self.render(claim);
                        self.setDiagnosisType(); // Bad code, Make the TypeOfDiagnosis compute work in the model
                    });
                },

                '{can.route} id': function (route, ev, id) {
                    if (id && route.attr('page') === 'claim') {
                        this.getClaimDetails(id);
                    }
                },

                alertLocked: function () {
                    App.alert({
                        title: '<i class="fa fa-lock"></i> Claim is Locked',
                        message: 'This claim cannot be edited, corrected, or resubmitted to Medicare.'
                    });
                },

                // --------------------------------------------------
                // UB04 Print
                // --------------------------------------------------

                '#Claim__UB04 click': function (el, ev) {
                    this.scope.attr('Claim').getUB04();
                },

                // --------------------------------------------------
                // Edit
                // --------------------------------------------------

                '#Claim__Claims click': function (el, ev) {
                    window.history.back();
                },

                '#Claim__Edit click': function (el, ev) {

                    // Edit if claim is not locked
                    var claim = this.scope.attr('Claim');
                    if (!claim.attr('_isLocked')) {
                        // Clone the claim
                        if (claim.attr('_isErrorTob')) {
                            this.copyClaim();
                        }
                        this.cachedClaim = claim.attr();
                        this.scope.attr('isEditing', true);
                    } else {
                        this.alertLocked();
                    }
                },

                '#Claim__CancelEdit click': function (el, ev) {

                    var self = this;
                    App.confirm({
                        title: 'Cancel',
                        message: 'Are you sure? All changes to the claim will be lost.',
                        ok: function () {
                            var claim = self.scope.attr('Claim');
                            if (!claim.attr('_id') && !claim.dolly) {
                                // If cancelling a new claim, return to claims list
                                // else load cached claim and return to claim summary
                                can.route.attr({ 'page': 'claims' }, true);
                            } else {
                                claim.attr(self.cachedClaim, true);
                                self.scope.attr('isEditing', false);
                            }
                        },
                        okText: "Yes, I'm sure.",
                        cancelText: 'Oops, nevermind.'
                    });
                },

                '#Claim__Save click': function (el, ev) {
                    var claim = this.scope.attr('Claim')
                    if (!claim.attr('ProviderId')) {
                        App.alert({
                            title: 'Provider Required',
                            message: 'You must select a provider before saving the claim.'
                        });
                    } else {
                        // TODO Save and Submit should be model functions
                        var status = claim.attr('_isSubmitted') ? 4 : 0;
                        this.updateClaim(status, 'Claim was successfully saved.');
                    }
                },

                '#Claim__Submit click': function (el, ev) {
                    var claim = this.scope.attr('Claim')
                    if (!claim.attr('ProviderId')) {
                        App.alert({
                            title: 'Provider Required',
                            message: 'You must select a provider before saving the claim.'
                        });
                    } else {
                        // this.scope.attr('isEditing', false);
                        this.updateClaim(1, 'Claim was successfully submitted to Medicare, you will be notified when it is complete.');
                    }
                },

                '#Claim__Copy click': function (el, ev) {
                    this.copyClaim();
                    this.scope.attr('isEditing', true);
                    App.alert({
                        title: 'Claim Copied',
                        message: 'You can make changes to this copy before submitting to Medicare.'
                    });
                },
                // Clones and submits after confirming
                '#Claim__Resubmit click': function (el, ev) {
                    var self = this;

                    App.confirm({
                        title: 'Resubmit Claim',
                        message: 'Are you sure you want to resubmit this claim?',
                        okText: 'Yes, Resubmit',
                        cancelText: 'Nevermind',
                        ok: function () {
                            var clone = self.scope.attr('Claim').clone();
                            self.scope.attr('Claim', clone);
                            self.updateClaim(1, 'Claim was successfully resubmitted to Medicare, you will be notified when it is complete.');
                        }
                    });
                },

                '#Claim__Cancel click': function () {
                    if (!App.isReadOnly()) {
                        this.scope.attr('type', 'Cancel');
                        App.loadModal('pages/claim/CancelReasonModal', this.scope);
                    }
                },

                '#Claim__Adjustment click': 'adjustClaim',


                '#Claim__Suppress click': function () {
                    var self = this,
                        scope = this.scope,
                        claim = scope.attr('Claim');

                    if (!App.isReadOnly()) {
                        App.confirm({
                            title: 'Suppress Claim',
                            message: 'Are you sure you want to suppress this claim?',
                            okText: 'Yes, I\'m sure',
                            cancelText: 'Cancel',
                            ok: function () {
                                self.updateClaim(7, 'Claim was successfully suppressed and submitted to Medicare, you will be notified when it is complete.');
                            }
                        })

                    }
                },

                copyClaim: function () {
                    var scope = this.scope,
                        clone = scope.attr('Claim').clone(),
                        remarks = scope.attr('Claim.Remarks');

                    scope.attr('Claim', clone);
                    scope.attr('Claim.ClaimTag', null);

                    if (remarks && remarks.length > 0) {
                        scope.attr('Claim.Remarks', remarks.replace(/\[AXXESS-(.+)\]/, ''));
                    }

                    this.setDiagnosisType();
                    can.route.removeAttr('id'); // Because this is a new claim
                },

                adjustClaim: function () {
                    var scope = this.scope;
                    scope.attr('type', 'Adjustment');
                    App.loadModal('pages/claim/CancelReasonModal', scope);
                },

                updateClaim: function (status, msg) {

                    // On Dark Days, do not allow users to submit a claim. On submit, status will be equal to 1.
                    if (Session.attr('isDarkDay') && status === 1) {
                        App.loadDarkDayModal();

                    } else if (Session.attr('isReadOnly') && !Session.attr('isAuthorizedBiller')) {
                        App.loadModal('modals/credential/CredentialModal', {
                            freeTrial: {
                                subtitle: 'This account is read-only. In order to submit this claim, please login with your DDE credentials.'
                            }
                        });

                    } else {

                        var self = this,
                            scope = this.scope,
                            claim = scope.attr('Claim'),
                            operation = "save";

                        // DUMB TODO backend should do this
                        claim.attr('HicNumber', claim.attr('Patient.HicNumber'));

                        if (!claim.attr('_isLocked')) {
                            App.loading();
                            claim.attr('Status', status);

                            // If the type of bill is 327 and the status code is Paid then it is a claim adjustment
                            // If the type of bill is 327 and the status code is not Paid or isPostPayReview then the user is editing a 327
                            if ((this.scope.attr('type') === "Adjustment" || claim.attr('TypeOfBill') === '327') && (claim.attr('_isPaid') || claim.attr('_isPostPayReview'))) {
                                operation = "adjust";
                            } else if (claim.attr('_isSuppressing')) {
                                operation = "suppress";
                            }

                            claim[operation]()
                                .done(function () {
                                    self.handleSaveSuccess(status, msg);
                                })
                                .always(function () {
                                    App.loading(false);
                                });

                        } else {
                            this.alertLocked();
                        }
                    }
                },

                handleSaveSuccess: function (status, msg) {
                    this.scope.attr('isEditing', false);
                    App.alert({
                        title: 'Success',
                        message: msg
                    });

                    if (status === 1) { // if submit, go to claim list
                        can.route.attr({ page: 'claims' }, true);
                    } else if (status === 0 || status === 4) {
                        can.route.attr({
                            page: 'claims',
                            box: 'drafts'
                        }, true)
                    }
                },

                // --------------------------------------------------
                // Side Navigation
                // --------------------------------------------------

                '[data-section] click': function (el, ev) {
                    var scope = this.scope,
                        name = el.data('section'),
                        claim = scope.attr('Claim');
                    // Adding the selected section to the scope,
                    // Doing this so that the cancel modal can show the selected section
                    scope.attr('sectionName', name);

                    if (claim.attr('_isAdjustable')) {
                        this.adjustClaim();
                    } else {
                        // Clone the claim
                        if (claim.attr('_isErrorTob')) {
                            this.copyClaim();
                        }

                        if (scope.attr('isEditing') === false)
                            scope.attr('isEditing', true);

                        if (name === 'Top') {
                            window.scrollTo(0, 0);
                        } else {
                            var section = this.element.find('section#' + name);

                            if (section.length)
                                window.scrollTo(window.scrollX, section.offset().top);

                        }

                        this.selectSection();
                    }

                },

                openAside: function () {
                    if (this.aside)
                        this.aside
                            .unbind()
                            .show()
                            .toggleClass(this.options.animation.open, true)
                            .toggleClass(this.options.animation.close, false);
                    this.selectSection();
                },

                closeAside: function () {
                    if (this.aside)
                        this.aside
                            .toggleClass(this.options.animation.open, false)
                            .toggleClass(this.options.animation.close, true)
                            .one(App.util.onAnimationEnd, function () {
                                $(this).hide();
                            });
                },

                selectSection: function () {
                    var tab = this.aside.find('a[data-section="' + this.scope.attr('sectionName') + '"]').addClass('active');
                    this.aside.find('a').not(tab).removeClass('active');
                },

                // --------------------------------------------------
                // Bindings
                // --------------------------------------------------

                '[name="TypeOfBill"] change': function (el, ev) {
                    var claim = this.scope.attr('Claim'),
                        $EndDate = this.element.find('[name="EndDate"]');

                    // TypeOfBill 32A is phasing out 322 RAPs in 2022. 
                    // It can be treated as the same claim type as 322.
                    if (claim.attr('TypeOfBill') === '322' 
                        || claim.attr('TypeOfBill') === '32A') {
                        if(claim.attr('TypeOfBill') === '32A') {
                            this.element.find('#Claim__ServiceLines').hide();
                            this.element.find('#Claim__ServiceLines__Aside').hide();
                        } else {
                            this.element.find('#Claim__ServiceLines').show();
                            this.element.find('#Claim__ServiceLines__Aside').show();
                        }
                        claim.attr('TypeOfClaim', 1);
                        $EndDate.prop('disabled', true);
                        if (claim.attr('StartDate'))
                            claim.attr('EndDate', claim.attr('StartDate'));
                    } else if (claim.attr('TypeOfBill') === '329') {
                        claim.attr('TypeOfClaim', 2);
                        $EndDate.prop('disabled', false);
                        if (claim.attr('StartDate') && (
                            claim.attr('EndDate') === undefined ||
                            claim.attr('EndDate') === claim.attr('StartDate')))
                            claim.attr('EndDate', moment.utc(claim.attr('StartDate')).add(59, 'days').format());
                    } else if (claim.attr('TypeOfBill') === '341') {
                        claim.attr('TypeOfClaim', 0);
                    }

                },

                '[name="StartDate"] change': function (start, ev) {
                    var claim = this.scope.attr('Claim'),
                        startDate = claim.attr('StartDate');

                    if (startDate) {
                        var endDate = moment.utc(startDate).add(59, 'days');
                        $('[name="EndDate"]').datepicker('setEndDate', new Date(endDate.format('YYYY-MM-DD HH:mm')));

                        if (claim.attr('TypeOfBill') === '322'
                            || claim.attr('TypeOfBill') === '32A'
                            || claim.attr('TypeOfBill') === '32D')
                            claim.attr('EndDate', startDate);

                        if (claim.attr('TypeOfBill') === '329' && !claim.attr('EndDate'))
                            claim.attr('EndDate', endDate.format());

                    }
                },

                '[name="EndDate"] change': 'setDiagnosisType',

                setDiagnosisType: function (end, ev) {
                    var claim = this.scope.attr('Claim'),
                        startDate = claim.attr('StartDate'),
                        diagnosisType = 'icd9';

                    if (startDate) {
                        var icd10DateStr = moment.utc('2015-10-01').format('YYYYMMDD'),
                            startDateStr = moment.utc(startDate).format('YYYYMMDD');

                        if (startDateStr >= icd10DateStr)
                            diagnosisType = 'icd10';

                    }

                    claim.attr('TypeOfDiagnosis', diagnosisType);
                },

                '[name="TypeOfDiagnosis"] change': function () {
                    var diagnosisCodeEl = this.element.find('claim-diagnosiscodes');
                    diagnosisCodeEl.data('bootstrapValidator').revalidateField('Claim.DiagnosisCodes.Principal.Code');
                    diagnosisCodeEl.data('bootstrapValidator').revalidateField('Code');
                },

                // --------------------------------------------------
                // Interaction
                // --------------------------------------------------

                '.more-physicians click': function (el, ev) {
                    el.hide();
                    this.element.find('#Claim__MorePhysicians').show();
                },

                '#Claim__Delete click': function (el, ev) {

                    // TODO Check if we can delete, only delete unsubmitted claims.

                    var self = this;

                    App.confirm({
                        title: 'Delete Claim',
                        message: 'Are you sure you want to delete this claim? This cannot be undone.',
                        okText: 'Yes, I\'m sure',
                        cancelText: 'Cancel',
                        ok: function () {
                            self.scope.attr('Claim').destroy();
                            can.route.attr({ page: 'claims' });
                        }
                    })
                },

                '#Claim__Move click': function (el, ev) {
                    var self = this;
                    App.confirm({
                        title: 'Move Claim',
                        message: 'Are you sure you want to move this claim? This cannot be undone.',
                        okText: 'Yes, I\'m sure',
                        cancelText: 'Cancel',
                        ok: function () {
                            self.scope.attr('Claim').attr('Status', 3).save();
                            can.route.attr({ page: 'claims' });
                        }
                    })
                },

                '#Adr__Report click': function (el, ev) {
                    App.loadModal('modals/claim/AdrReportModal', {
                        id: this.scope.attr('Claim.EntityId')
                    });
                },

                '.Is__Alphanumeric keypress': function(el, ev) {
                    return /[a-z0-9]/i.test(ev.key);
                },

                '.Is__Alpha keypress': function(el, ev) {
                    return /[a-z]/i.test(ev.key);
                },

                '.Is__ValidNameInput keypress': function(el, ev) {
                    return /[a-z-.' ]/i.test(ev.key);
                },

            });
    });

/*

'Claim.ProviderId': {
	validators: {
		notEmpty: {
			message: 'Provider is required.'
		}
	}
},
'TypeOfBill': {
	validators: {
		notEmpty: {
			message: 'Type Of Bill is required.'
		}
	}
},
'StartDate': {
	validators: {
		notEmpty: {
			message: 'Start Date is required.'
		},
		date: {
			message: 'Start Date must have format MM/DD/YYYY.'
		},
		callback: {
			message: 'Start Date cannot be in the future.',
			callback: function (value, validator, $field) {
				return !moment(enddate.val()).isAfter();
			}
		}
	}
},
'EndDate': {
	validators: {
		notEmpty: {
			message: 'End Date is required.'
		},
		date: {
			message: 'End Date must have format MM/DD/YYYY.'
		},
		callback: {
			callback: function (value, validator, $field) {

				if (moment(startdate.val()).isAfter(enddate.val())) {
					return {
						valid: false,
						message: 'End Date cannot be before Start Date.'
					}
				}

				if (moment(enddate.val()).isAfter()) {
					return {
						valid: false,
						message: 'End Date cannot be in the future.'
					}
				}

				return { valid: true };
			}
		}
	}
}

*/;
